














import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Header extends Vue {
  private onSelect (id: string) {
    const nav = document.getElementsByTagName('nav')[0]
    const el = document.getElementById(id)

    if (nav && el) {
      window.scrollTo({
        left: 0,
        top: el.offsetTop - nav.offsetHeight,
        behavior: 'smooth'
      })
    }
  }
}
